// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3upGl","title":"ClientCherryInfo_title__tLRc-","itemText":"ClientCherryInfo_itemText__3zooz"};